import { render, staticRenderFns } from "./device-configuration-templates.vue?vue&type=template&id=cbb781e4&scoped=true"
import script from "./device-configuration-templates.vue?vue&type=script&lang=js"
export * from "./device-configuration-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb781e4",
  null
  
)

export default component.exports